import type { FC } from 'react';

import type { ExchangeRateInfo } from '@shared/core-types';
import { numberToAmount } from '@shared/amount-utils';

import { LocalizedAmount } from '../localized-amount/LocalizedAmount';

interface Props {
    rateInfo: Pick<
        ExchangeRateInfo,
        'fixedCurrency' | 'fixedCurrencyRateUnit' | 'rate' | 'variableCurrency'
    >;
}

export const FormattedRate: FC<Props> = ({ rateInfo }) => {
    const { fixedCurrency, fixedCurrencyRateUnit, variableCurrency, rate } = rateInfo;
    const rateAmount = numberToAmount(rate);

    return (
        <>
            {`${fixedCurrencyRateUnit} ${fixedCurrency} =`}&nbsp;
            <LocalizedAmount amount={rateAmount} inheritFontWeight />
            &nbsp;{variableCurrency}
        </>
    );
};
